<template lang="html">
<div class="subpage">
    <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="true" label-position="right" label-width="120px">
        <!-- 委员会名称 -->
        <el-form-item label="团队名称" prop="name">
            <el-input size="medium" class="inpText" v-model="params.name" placeholder="请输入标题"></el-input>
        </el-form-item>
        <!-- 专业领域 数据字典 -->
        <el-form-item label="专业领域" prop="majorId">
            <all-select code="zyly" v-model="params.majorId" paramsKey="majorId" @change="zylySelectChange" plaText="专业领域" />
        </el-form-item>
        <!--  介绍 -->
        <el-form-item label="咨询电话" prop="cellphone">
            <el-input size="medium" v-model="params.cellphone"></el-input>
        </el-form-item>
        <!--  介绍 -->
        <el-form-item label="介绍" prop="introduce">
            <el-input style="width:750px;" type="textarea" v-model="params.introduce"></el-input>

        </el-form-item>
        <el-form-item label="主页图" prop="homeChart">
            <imgs-upload v-model="params.homeChart" @change="fileChange" tips="（推荐尺寸1920*600）" limit="1" />
        </el-form-item>
        <el-form-item label="社交账号">
            <el-button @click="openSj" type="primary" size="small">添加账号</el-button>
            <el-table :data="params.lawyerSocialaccountsList" :header-cell-style="{background:'#F3F4F7',color:'#555'}" style="width: 80%" border>
                <el-table-column prop="platform" label="社交平台">
                </el-table-column>
                <el-table-column prop="account" label="社交账号" width="180">
                </el-table-column>
                <el-table-column prop="webUrl" label="网址" width="180">
                </el-table-column>
                <el-table-column prop="urlQrcode" label="账号二维码" width="180">
                    <!-- <template slot-scope="scope">
                        <el-image style="width: 100px; height: 100px" :src="url" :preview-src-list="srcList">
                        </el-image>

                    </template> -->
                </el-table-column>
                <el-table-column width="120" label="操作" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" @click="delRow( scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-form-item>
        <el-form-item label="推广二维码" prop="name">
            <span @click="downloadImg(indata.id)">
                <el-tooltip content="点击下载二维码" placement="top-start">
                    <vue-qr :ref="'Qrcode' + indata.id" :text="urlQrcode(indata)" :margin="10" :size="500" :width="100" />
                </el-tooltip>
            </span>
        </el-form-item>
        <!-- 状态 -->
        <el-form-item label="状态" prop="status">
            <el-radio-group v-model="params.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="2">停用</el-radio>
            </el-radio-group>
            &nbsp;&nbsp;&nbsp;&nbsp;停用后，将不在官网上展示，自定义链接不支持访问

        </el-form-item>

    </el-form>

    <el-dialog title="新增社交" :visible.sync="dialogVisible" @closed="closedDialog" :close-on-click-modal="false" width="560px">
        <el-form :model="fromDialog" label-width="100px" label-position="right">
            <el-form-item label="社交平台">
                <dic-select code="sjpt" v-model="fromDialog.platformId" paramsKey="major" @change="selectChange" plaText="社交平台" />
            </el-form-item>
            <el-form-item label="账号名称">
                <el-input v-model="fromDialog.account" size="medium"></el-input>
            </el-form-item>
            <el-form-item label="网址">
                <el-input v-model="fromDialog.webUrl" size="medium"></el-input>
            </el-form-item>
            <el-form-item label="账号二维码">
                <imgs-upload v-model="fromDialog.urlQrcode" @change="fileChange" tips="（推荐尺寸160*160）" limit="1" />
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="addDialog" size="small">确 定</el-button>
            <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import VueQr from 'vue-qr';
export default {
    props: ['indata'],
    components: {
        VueQr
    },
    data() {
        return {
            dialogVisible: false,
            fromDialog: {
                id: '',
                webUrl: '', //地址
                urlQrcode: '', //二维码
                lawyerId: '', //lawyerId
                platform: '', //平台
                platformId: '',
                account: '', //账号
                teamId: '', //律师团队ID
                class_type: 'TJingshiLawyerSocialaccounts',
            },

            params: {
                name: '', //团队名称
                majorId: '', //专业领域ID<多选>
                major: '', //专业领域ID<多选>
                cellphone: '', //咨询电话
                introduce: '', //介绍
                homeChart: '', //主页图
                lawyerSocialaccountsList: [], //社交账号
                status: 0,

            },
            rules: {
                name: [{
                    required: true,
                    message: '团队名称不能为空',
                    trigger: 'blur'
                }],
                majorId: [{
                    required: true,
                    message: '专业领域不能为空',
                    trigger: 'blur'
                }],
                // homeChart: [{
                //     required: true,
                //     message: '主页图不能为空',
                //     trigger: 'blur'
                // }],
                cellphone: [{
                    required: true,
                    message: '咨询电话不能为空',
                    trigger: 'blur'
                }],
                introduce: [{
                    required: true,
                    message: '介绍不能为空',
                    trigger: 'blur'
                }],
            }
        }
    },
    watch: {
        indata: function (e) {
            console.log(e);
            var vues = this;
            if (e) {
                for (let key in this.params) {
                    if (e.hasOwnProperty(key)) {
                        this.params[key] = e[key];
                    }
                }
                this.handleClassType(this.params.lawyerSocialaccountsList, 'TJingshiLawyerSocialaccounts');

            }
        }
    },
    methods: {
        delRow(row) {
            for (var i = 0; i < this.params.lawyerSocialaccountsList.length; i++) {
                if (this.params.lawyerSocialaccountsList[i].platformId + this.params.lawyerSocialaccountsList[i].account === row.platformId + row.account) {
                    this.params.lawyerSocialaccountsList.splice(i, 1);
                }
            }
        },
        selectChange(e) {
            // console.log(e);
            this.fromDialog.platform = e.name;
        },
        zylySelectChange(e) {
            console.log(e);
            this.params.major = e.name;
        },

        addDialog() {
            var account = {
                webUrl: this.fromDialog.webUrl, //地址
                urlQrcode: this.fromDialog.urlQrcode, //二维码
                lawyerId: this.fromDialog.lawyerId, //lawyerId
                platform: this.fromDialog.platform, //平台
                platformId: this.fromDialog.platformId, //平台
                account: this.fromDialog.account, //账号
                teamId: this.fromDialog.teamId, //律师团队ID
                class_type: 'TJingshiLawyerSocialaccounts',
            };
            this.params.lawyerSocialaccountsList.push(account);
            this.dialogVisible = false;
        },
        openSj() {
            this.dialogVisible = true;
        },
        closedDialog() {
            this.fromDialog = {
                id: '',
                webUrl: '', //地址
                urlQrcode: '', //二维码
                lawyerId: '', //lawyerId
                platform: '', //平台
                platformId: '', //平台
                account: '', //账号
                teamId: '', //律师团队ID
                class_type: 'TJingshiLawyerSocialaccounts',
            };
        },
        handleClassType(arr, class_type) {
            if (arr) {
                for (var i = 0; i < arr.length; i++) {
                    if (!arr[i].hasOwnProperty('class_type')) {
                        arr[i]['class_type'] = class_type;
                    }
                }
            }
        },
        imgChange(e) {
            console.log(e);
        },
        saveReturn: function () {
            var vues = this;
            return new Promise((reslove, reject) => {
                console.log(vues.params);
                vues.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        reslove(vues.params);
                    } else {
                        reslove(false);
                    }
                })
            })
        },
        downloadImg(link_id) {
            const iconUrl = this.$refs['Qrcode' + link_id].$el.src
            const a = document.createElement('a')
            const event = new MouseEvent('click')
            a.download = link_id
            a.href = iconUrl
            a.dispatchEvent(event)
        },
        urlQrcode(data) {
            var domain = 'jingshcqlawyer.com';
            if (data.customLink) {
                domain = data.customLink + '/';
            } else {
                domain = domain + '/' + data.modelLink + '?id=' + data.id;
            }
            var url = 'http://' + domain;
            return url;
        },
        // qrcode(data) {
        //     var domain = 'jingshcqlawyer.com';
        //     console.log('qrcode',data);
        //     if(data.customLink){
        //         domain=data.customLink+'/';
        //     }else{
        //         domain=domain+'/'+data.modelLink+'?id='+data.id;
        //     }
        //     var url='http://'+domain;
        //     this.$refs.qrCodeUrl.innerHTML = ''
        //     new QRCode(this.$refs.qrCodeUrl, {
        //         text: url, // 需要转换为二维码的内容
        //         width: 150,
        //         height: 150,
        //         colorDark: '#000000',
        //         colorLight: '#ffffff',
        //         correctLevel: QRCode.CorrectLevel.H
        //     })
        // },
    },
    created: function () {
        var vues = this;
        if (this.indata) {
            for (let key in this.params) {
                if (this.indata.hasOwnProperty(key)) {
                    this.params[key] = this.indata[key];
                }
            }
            console.log(this.indata);

        }
    }
}
</script>

<style lang="scss" scoped>
.qrcode {
    display: inline-block;

    img {
        width: 168px;
        height: 168px;
        background-color: #fff; //设置白色背景色
        padding: 6px; // 利用padding的特性，挤出白边
        box-sizing: border-box;
    }
}
</style>

<style lang="css">
.subpage .el-input__inner {
    border-radius: 0px !important;
}

.subpage .selects {
    width: 240px !important;
}

.subpage .el-input {
    width: 240px !important;
}

.subpage .el-table__header tr,
.subpage .el-table__header th {
    padding: 0;
    height: 40px;
}

.subpage .el-table__body tr,
.subpage .el-table__body td {
    padding: 0;
    height: 40px;
}
</style>



// WEBPACK FOOTER //
// subpage1.vue?2ca8a116